import { render, staticRenderFns } from "./Naplata2.vue?vue&type=template&id=552255b9"
import script from "./Naplata2.vue?vue&type=script&lang=js"
export * from "./Naplata2.vue?vue&type=script&lang=js"
import style0 from "./Naplata2.vue?vue&type=style&index=0&id=552255b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports